import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam, useParseParams } from '@hooks/params';
import { findCancerQuoteParamsSchema } from '@apis/CancerQuoteApi';

import { cancerQuoteFetch, CancerQuoteFetchPayload, cancerQuoteFind, CancerQuoteFindPayload } from './action';
import { selectCancerQuoteBuyRoute } from './selector';
import { CancerQuoteBuyNewPageParams } from './route';

export const useCancerQuoteBuyNewPageParams = () =>
  useParseParams<CancerQuoteBuyNewPageParams>(findCancerQuoteParamsSchema);

export const useCancerQuoteFind = () => {
  const dispatch = useDispatch();
  const params = useCancerQuoteBuyNewPageParams();
  const { cancerQuote } = useSelector(selectCancerQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: CancerQuoteFindPayload = params;
    dispatch(cancerQuoteFind(payload));
  });
  return cancerQuote;
};

export const useCancerQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { cancerQuote } = useSelector(selectCancerQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: CancerQuoteFetchPayload = { orderNumber };
    dispatch(cancerQuoteFetch(payload));
  });
  return cancerQuote;
};
